import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import merge from 'lodash/merge';
import { wishlistNameStyles } from 'components/domain/wishlist/WishlistItem.styles';

export const WishlistItemsWrapper = styled.div(({ theme: { space } }) => ({
  paddingLeft: '2px',
  paddingBottom: space[1],
}));

export const WishListItemWrapper = styled.div.attrs({
  'data-id': `wishlist-item`,
  role: 'button',
  tabIndex: 0,
})<{ active?: boolean }>(
  sx2CssThemeFn(
    {
      flexDirection: 'column',
      width: [null, '267px'],
      borderRadius: 'default',
      overflow: 'hidden',
      position: 'relative',
      pl: '0px',
      alignItems: 'stretch',
      color: 'initial',
      cursor: 'pointer',
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
      mr: '26px',
      mb: 1,
      ':last-child': {
        mr: 0,
      },
    },
    {
      '.wishlist-item-image': {
        objectFit: 'cover',
        width: '100%',
        height: '239px',
        display: 'block',
      },
      '.wishlist-item-delete-button': {
        position: 'absolute',
        height: '30px',
        width: '30px',
        top: 2,
        right: 2,
        bg: 'background',
        color: 'black',
      },
    }
  ),
  ({ active }) =>
    active
      ? sx2CssThemeFn({
          backgroundColor: 'primary',
          color: 'white',
          '&:after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: '2px solid',
            borderColor: 'primary',
            pointerEvents: 'none',
          },
        })
      : {}
);

export const WishListImagesWrapper = styled.div(({ theme: { colors } }) => ({
  display: 'flex',
  height: '239px',
  backgroundColor: colors.lightGreyFirst,
  '.wishlist-item-icon': {
    margin: 'auto',
    color: colors.darkGray,
    height: '35px',
    width: '35px',
  },
}));

export const WishListItemTitleWrapper = styled.div(({ theme: { FONT_SIZE } }) =>
  sx2CssThemeFn({
    display: 'flex',
    '.wishlist-item-title': merge({}, wishlistNameStyles, {
      ...FONT_SIZE.LARGE,
      flex: '0 1 auto',
    }),
    '.wishlist-item-editable-button': {
      marginLeft: 1,
      flexShrink: 0,
      bg: 'background',
      height: '30px',
      width: '30px',
      color: 'black',
    },
    '.wishlist-item-span': {
      flex: '1 1px',
    },
    '.wishlist-item-product-amount-span': {
      marginLeft: 'auto',
      flexShrink: 0,
    },
    px: [2, 3],
    py: [2, '14px'],
    alignItems: 'center',
  })
);
